import type { GetRiskAssessmentResultByIdResponseRow as RiskAssessmentResultResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetRiskAssessmentResultByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRiskAssessmentResultByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetRiskAssessmentResultByIdArgs = {
  id: string;
};

export const useGetRiskAssessmentResultById = createQueryHook<
  UseGetRiskAssessmentResultByIdArgs,
  RiskAssessmentResultResponseRow | null,
  GetRiskAssessmentResultByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.assessment.riskAssessmentResultById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    risk_assessment_result: data ? [data] : [],
  }),
  graphqlDocument: GetRiskAssessmentResultByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
